import { render, staticRenderFns } from "./HotKeywordsCreate.vue?vue&type=template&id=256447e3&scoped=true&"
import script from "./HotKeywordsCreate.vue?vue&type=script&lang=js&"
export * from "./HotKeywordsCreate.vue?vue&type=script&lang=js&"
import style0 from "./HotKeywordsCreate.vue?vue&type=style&index=0&id=256447e3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256447e3",
  null
  
)

export default component.exports